import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const pageVariants = {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 },
  };


const Collection = () => {

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
   fetch(`${process.env.REACT_APP_API_URL}/api/products`) // Ensure your backend is running
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        return response.json();
      })
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        setError(error.message);
        setLoading(false);
      });
  }, []);

  /* const products = [
    { id: 1, name: "Elegant Cushion", price: "$49", img: "/images/coll11.jpg" },
    { id: 2, name: "Modern Charm", price: "$59", img: "/images/coll22.jpg" },
    { id: 3, name: "Timeless Classic", price: "$39", img: "/images/coll33.jpg" },
    { id: 4, name: "Bold Elegance", price: "$69", img: "/images/coll44.jpg" },
    // Add more products as needed
  ]; */

  return (
    <motion.div initial="initial"
    animate="animate"
    exit="exit"
    variants={pageVariants} > 
      <div className="collection-containerthree">
        <h2 className="collection-titlethree">Notre Collection</h2>

        {loading && <p>Loading products...</p>}
        {error && <p className="error-message">{error}</p>}

        <div className="product-gridthree">
          {products.length > 0 ? (
            products.map((product) => (
              <div className="product-itemthree" key={product.id}>
                <img src={product.image_url} alt={product.name} className="product-imagethree" />
                <div className="product-infothree">
                  <h3>{product.name}</h3>
                  <p>TND{product.price}</p>
                </div>
              </div>
            ))
          ) : (
            !loading && <p>No products available.</p>
          )}
        </div>

      {/* Pagination */}
      <div className="paginationthree">
        <button className="page-btnthree">1</button>
        <button className="page-btnthree">2</button>
        <button className="page-btnthree">3</button>
        {/* Add more page buttons or dynamic pagination logic */}
      </div>
    </div> 
        

    </motion.div>
    
  );
};

export default Collection;
